import {
  BUSINESS_TRUSTPASS_FETCH_SUCCESS,
  BUSINESS_TRUSTPASS_UPDATE_SUCCESS,
  BUSINESS_TRUSTPASS_HYDRATE,
  BUSINESS_TRUSTPASS_STATUS_UPDATE,
  BUSINESS_TRUSTPASS_DOCUMENT_UPDATE,
} from '../actionTypes';

let initialState = {
  requirements: [],
  submitted_at: null,
}

export default function business(state = initialState, action) {
  switch(action.type) {

    // TODO: Confirm and remove
    //case 'USER_RECEIVE_DETAILS_AND_TOKEN': // move this properly later
      //return action.payload.active_business_trustpass
    //case 'RECEIVE_BUSINESS_TRUSTPASS': // move this properly later

    case BUSINESS_TRUSTPASS_FETCH_SUCCESS:
      return action.payload || state;
    case BUSINESS_TRUSTPASS_UPDATE_SUCCESS:
      return action.payload;
    case BUSINESS_TRUSTPASS_HYDRATE:
      return {...state, ...action.payload};
    case BUSINESS_TRUSTPASS_DOCUMENT_UPDATE:
      if(!state || !state.requirements) return state;
      const updatedDoc = action.payload;
      let newRequirements = state.requirements.map((requirement) => {
        if (requirement.identifier === updatedDoc.identifier) {
          return {...requirement, object: updatedDoc.object}
        }

        return requirement;
      })

      return {...state, requirements: newRequirements}
    case BUSINESS_TRUSTPASS_STATUS_UPDATE:
      if(!state || !state.requirements) return state;
      let updatedRequirements = state.requirements.map((requirement) => {
        return { ...requirement, status: action.payload }
      })
      return {...state, requirements: updatedRequirements, submitted_at: Date.now()};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/trustpass/reducers/business.js